import React, { PureComponent } from 'react';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import { CircularProgress } from 'material-ui/Progress';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Order from 'routes/Orders/components/RefundOrder';
import PageNumbers from './components/PageNumbers';
import { actions as userActions } from 'modules/user';

export class Results extends PureComponent {
  render() {
    const {
      currentPage,
      loading,
      pageSize,
      results,
      savedUserEmailSearchText,
      savedOrderIdSearchText,
      savedUserFirstNameSearchText,
      savedUserLastNameSearchText,
      totalResults
    } = this.props;

    if (loading) {
      return <CircularProgress style={{marginLeft: '60px'}} color="primary" />;
    }

    const resultsLength = totalResults;

    return (
      <Grid item xs={12} >
        <Grid container spacing={0} direction="column" style={{backgroundColor: '#d3d3d3', padding: '16px'}}>
          { savedOrderIdSearchText.length ? <Typography variant="headline">Order Id: {savedOrderIdSearchText}</Typography> : null }
          { savedUserEmailSearchText.length ? <Typography variant="headline">Email: {savedUserEmailSearchText}</Typography> : null }
          { savedUserFirstNameSearchText.length ? <Typography variant="headline">First Name: {savedUserFirstNameSearchText}</Typography> : null }
          { savedUserLastNameSearchText.length ? <Typography variant="headline">Last Name: {savedUserLastNameSearchText}</Typography> : null }
          <Typography variant="headline">Total Results: {resultsLength}</Typography>
        </Grid>
        <PageNumbers />
        <Grid item xs={12} style={{margin: '16px 0'}}>
          <Button
            onClick={() => this.props.logoutUser()}
          >Logout
          </Button>
        </Grid>
        { results && results.map((order, i) => {
          if (order) return (
            <Order key={i} resultNum={currentPage*pageSize+i+1} order={order} />
          );
        })}
        <PageNumbers/>
        { results && results.length ? <Grid item xs={12} style={{margin: '16px 0'}}>
          <Button
            onClick={() => this.props.logoutUser()}
          >Logout
          </Button>
        </Grid> : null }
      </Grid>
    );
  }
}

Results.propTypes = {
  currentPage: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  pageSize: PropTypes.number.isRequired,
  results: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })),
  savedUserEmailSearchText: PropTypes.string.isRequired,
  savedOrderIdSearchText: PropTypes.string.isRequired,
  savedUserFirstNameSearchText: PropTypes.string.isRequired,
  savedUserLastNameSearchText: PropTypes.string.isRequired,
  totalResults: PropTypes.number.isRequired
};

Results.defaultProps = {
  results: []
};

const mapStateToProps = state => ({
  currentPage: state.admin.currentPage,
  logoutUser: PropTypes.func.isRequired,
  loading: state.admin.loading,
  pageSize: state.admin.pageSize,
  results: state.admin.results,
  savedUserEmailSearchText: state.admin.savedUserEmailSearchText,
  savedOrderIdSearchText: state.admin.savedOrderIdSearchText,
  savedUserFirstNameSearchText: state.admin.savedUserFirstNameSearchText,
  savedUserLastNameSearchText: state.admin.savedUserLastNameSearchText,
  totalResults: state.admin.totalResults
});

const mapDispatchToProps = dispatch => ({
  logoutUser: () => {
    dispatch(userActions.logoutUser());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Results);



// WEBPACK FOOTER //
// ./routes/Orders/containers/Refunds/containers/Results/index.jsx